export default __webpack_public_path__ + "static/media/pix-logo.8ce0be2b.svg";